<template>
  <div>
    <loading v-if="isLoading" />

    <!-- Tabela de Usuários -->
    <v-data-table :headers="headers" :items="desserts" :sort-desc="true" class="elevation-1 user-table" :search="search"
      :loading="isLoading" loading-text="Carregando usuários..." no-data-text="Nenhum usuário encontrado" :footer-props="{
        'items-per-page-text': 'Usuários por página',
        'page-text': '{0}-{1} de {2}'
      }" mobile-breakpoint="600" :items-per-page="10">

      <!-- Barra Superior Melhorada -->
      <template v-slot:top>
        <v-toolbar flat color="white" class="toolbar-custom">
          <div class="toolbar-content d-flex align-center justify-space-between flex-wrap">

            <!-- Filtros e Ações - Alinhado à esquerda -->
            <div class="d-flex align-center flex-wrap">

              <!-- Chip de título -->
              <v-chip class="ma-2" color="primary" outlined pill>
                <v-icon left>mdi-account-group</v-icon>
                Painel de Usuários
              </v-chip>

              <!-- Campo de busca -->
              <div class="search-container d-flex align-center">
                <v-text-field v-model="search" append-icon="mdi-magnify" label="Pesquisar usuários..." single-line
                  hide-details outlined dense class="search-field" style="max-width: 240px;"
                  @keyup.enter="initialize(search)"></v-text-field>

                <v-btn v-if="search" @click="initialize(search)" icon color="primary" class="ml-2 refresh-btn">
                  <v-icon>mdi-refresh</v-icon>
                </v-btn>
              </div>

            </div>

            <!-- Campo de pesquisa + status - Alinhado à direita -->
            <div class="d-flex align-center flex-wrap">



              <v-row>
                <!-- Select de Role -->
                <v-select v-model="selectedRole" :items="rolesDisponiveis" :item-value="item => item" item-text="nome"
                  label="Selecione o Cargo que deseja bloquear" dense outlined hide-details class="ml-2"
                  style="max-width: 280px;"></v-select>

                <!-- Botão Bloquear por Role ou Seleção -->
                <v-btn color="error" class="ml-2 py-5" :disabled="usuariosSelecionados.length === 0 && !selectedRole"
                  @click="desbloquearOuBloquearUsuariosPorRole" small>
                  <v-icon left small>mdi-lock-outline</v-icon>
                  Desbloquear/Bloquear Todos
                </v-btn>
              </v-row>

              <!-- Indicadores de status -->
              <div class="status-indicators d-flex align-center ml-8">
                <v-chip small color="green lighten-5" text-color="green" class="mr-2">
                  <v-avatar left color="green" size="24">
                    <span class="white--text">{{ quantUsuariosActivos }}</span>
                  </v-avatar>
                  Ativos
                </v-chip>
                <v-chip small color="red lighten-5" text-color="red">
                  <v-avatar left color="red" size="24">
                    <span class="white--text">{{ quantUsuariosInativos }}</span>
                  </v-avatar>
                  Inativos
                </v-chip>
              </div>
            </div>
          </div>
        </v-toolbar>





      </template>


      <!-- Coluna de Foto -->
      <template v-slot:item.photo="{ item }">
        <v-avatar size="36" class="user-avatar">
          <img :src="getPhoto(item)" alt="Avatar" class="avatar-img" />
        </v-avatar>
      </template>

      <!-- Coluna de Índice -->
      <template v-slot:item.index="{ item }">
        <span>{{ desserts.indexOf(item) + 1 }}</span>
      </template>

      <!-- Coluna de Status -->
      <template v-slot:item.ver_status="{ item }">
        <v-chip small :color="item.activo === 'activa' ? 'green lighten-4' : 'red lighten-4'"
          :text-color="item.activo === 'activa' ? 'green darken-2' : 'red darken-2'">
          {{ item.activo === 'activa' ? 'Ativo' : 'Inativo' }}
        </v-chip>
      </template>

      <!-- Coluna de Ações -->
      <template v-slot:item.action="{ item }">
        <v-menu offset-y left transition="slide-y-transition">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" color="grey darken-1" class="action-btn">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list dense class="action-menu">
            <v-list-item @click="showFileChooser(item)" v-if="funcaoUtilitarios.verificarFuncaoPed(2)">
              <v-list-item-icon>
                <v-icon color="blue">mdi-camera</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Alterar Foto</v-list-item-title>
            </v-list-item>

            <v-list-item @click="selecionarMenu(item, 2)" v-if="funcaoUtilitarios.verificarFuncaoPed(1)">
              <v-list-item-icon>
                <v-icon color="blue">mdi-lock-reset</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Mudar Senha</v-list-item-title>
            </v-list-item>

            <v-list-item @click="selecionarMenu(item, 5)" v-if="funcaoUtilitarios.verificarFuncaoPed(3)">
              <v-list-item-icon>
                <v-icon color="blue">mdi-email-edit</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Editar Email</v-list-item-title>
            </v-list-item>

            <v-list-item @click="selecionarMenu(item, 3)" v-if="funcaoUtilitarios.verificarFuncaoPed(4)">
              <v-list-item-icon>
                <v-icon color="blue">mdi-shield-account</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Mudar Permissão</v-list-item-title>
            </v-list-item>

            <v-list-item @click="selecionarMenu(item, 4)" v-if="funcaoUtilitarios.verificarFuncaoPed(5)">
              <v-list-item-icon>
                <v-icon :color="item.activo === 'activa' ? 'red' : 'green'">
                  {{ item.activo === 'activa' ? 'mdi-account-remove' : 'mdi-account-check' }}
                </v-icon>
              </v-list-item-icon>
              <v-list-item-title>
                {{ item.activo === 'activa' ? 'Inativar' : 'Ativar' }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-data-table>

    <!-- Input oculto para upload de foto -->
    <input style="display:none" ref="input" type="file" name="image" accept="image/*" @change="setImage" />

    <!-- Componentes Modais -->
    <carregarFoto :usuario="editedItem" :eventPhoto="eventPhoto" @fecharComponente="fecharTelaComponente"
      v-if="menuSelected === 1"></carregarFoto>

    <mudarsenha :usuario="editedItem" @fecharComponente="fecharTelaComponente" v-if="menuSelected === 2"></mudarsenha>

    <mudaremail :usuario="editedItem" @fecharComponente="fecharTelaComponente" v-if="menuSelected === 5"></mudaremail>
    <mudarpermissao :usuario="editedItem" @fecharComponente="fecharTelaComponente" v-if="menuSelected === 3">
    </mudarpermissao>
    <GlobalSnackbar ref="snackbar"/>

  </div>
</template>

<script>
import axios from "../../../plugins/axios";
import photoUser from "../../../utilitarios/photo.services";
import carregarFoto from "../componentes/usuario/carregarfoto.vue";
import mudarsenha from "./components/mudarsenha.vue";
import mudaremail from "./components/mudarEmail.vue";
import mudarpermissao from "./components/mudarpermissao.vue";
import loading from "../../../components/loading.vue";
import VueCropper from 'vue-cropperjs'
import 'cropperjs/dist/cropper.css'
import Swal from "sweetalert2";
const ls = require("local-storage");
import funcaoUtilitarios from '@/utilitarios/funcaoUtilitarios'

export default {
  components: {
    carregarFoto,
    mudarsenha,
    mudarpermissao,
    loading,
    mudaremail,
    VueCropper
  },
  data: () => ({
    funcaoUtilitarios: funcaoUtilitarios,
    eventPhoto: null,
    menuSelected: 0,
    dialogoUpload: false,
    imgSrc: "",
    text: "",
    flag_curso: "",
    flagUsuario: true,
    usuarios_permitidos: ls.get("usuarios_permitidos"),
    disabilitaRole: false,
    role_activo: ls.get("role"),
    save_status: false,
    search: "",

    selectedRole: null,
    rolesDisponiveis: [
      { nome: 'Coordenador', role: 'ROLE_COOR' },
      { nome: 'Pedagógico', role: 'ROLE_PED' },
      { nome: 'Professor', role: 'ROLE_PROF' },
      { nome: 'Estudante', role: 'ROLE_EST' }
    ],
    usuariosSelecionados: [], // deve ser alimentado pela tabela

    disativa: false,
    cursos: [],
    isLoading: false,
    funcionarios: [],
    desserts: [],
    dialog: false,
    progresso: false,
    headers: [
      { text: '#', value: 'index', width: '50px', align: 'center' },
      { text: "Foto", value: 'photo', width: '70px', align: 'center', sortable: false },
      { text: "Nome", value: "nomeUsuario" },
      { text: "Cod.", value: "idPessoa" },
      { text: "Cargo", value: "role_descricao" },
      { text: "Email", value: "username" },
      { text: "Status", value: "ver_status", width: '100px', align: 'center' },
      { text: "Modificado", value: "data_func", width: '120px' },
      { text: "Ações", value: "action", sortable: false, width: '80px', align: 'center' }
    ],
    editedIndex: -1,
    editedItem: {
      idFuncionario: "",
      idPessoa: "",
      email: "",
      nomeUsuario: "",
      autorizacoes_nome: "",
      enable: false,
      idusuario_autorizacao: "",
      newpassword: "",
      professor: 0,
      pkUsuario: 0,
      passwordnew: "",
    },
    defaultItem: {
      idFuncionario: "",
      idPessoa: "",
      email: "",
      nomeUsuario: "",
      autorizacoes_nome: "",
      enable: false,
      idusuario_autorizacao: "",
      newpassword: "",
      professor: 0,
    },
  }),

  computed: {
    role() {
      return ls.get("role");
    },
    quantUsuariosActivos() {
      return this.desserts.length > 0 ? this.desserts.filter((t) => t.enable === 1).length : 0;
    },
    quantUsuariosInativos() {
      return this.desserts.length > 0 ? this.desserts.filter((t) => t.enable !== 1).length : 0;
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.initialize();

    this.funcoesUsuarios.init();
  },

  methods: {

    // desbloquearUsuariosPorRole
    desbloquearOuBloquearUsuariosPorRole() {
      const idInstituicao = ls.get("i_id");
      if (this.usuariosSelecionados.length > 0) {
        Swal.fire({
          title: "Confirmar bloqueio",
          text: `Você está prestes a bloquear ${this.usuariosSelecionados.length} usuário(s) selecionado(s). Deseja continuar?`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Sim, bloquear",
          cancelButtonText: "Cancelar",
          reverseButtons: true,
          footer: '<p>⚠️ Para bloquear ou desbloquear apenas um usuário, utilize as opções individuais no menu de ações do usuário.</p>'
        }).then((result) => {
          if (result.isConfirmed) {
            // Chamada à API aqui
            this.$refs.snackbar.mostrar("Impossível desbloquear os usuários, por favor contacte o suporte!", "error");
          }
        });
      } else if (this.selectedRole) {
        Swal.fire({
          title: "Confirmar bloqueio",
          text: `Você está prestes a bloquear todos os usuários com o CARGO DE "${this.selectedRole.nome}". Deseja continuar?`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Sim, bloquear",
          cancelButtonText: "Cancelar",
          reverseButtons: true,
          footer: '<p>⚠️ Para bloquear ou desbloquear apenas um usuário, utilize as opções individuais no menu de ações do usuário.</p>'
        }).then(async (result) => {
          if (result.isConfirmed) {

            const result = await axios.post('bloquearUsuariosPorRole', {
              role: this.selectedRole,
              idInstituicao: idInstituicao
            })
            if (result.status === 200) {
              this.$refs.snackbar.mostrar("Os usuários foram bloqueados/desbloqueados com sucesso.", "success");
              this.initialize();
            } else {
              this.$refs.snackbar.mostrar("Ocorreu um erro ao tentar bloquear os usuários.", "error");
            }
          }
        });
      }
    },

    async initialize(search) {
      this.isLoading = true;
      let payload = ""
      try {
        if (!search) payload = '{"find":"all" , "role":"F"}';
        else payload = '{"find":"' + search + '"}';
        this.desserts = await axios.get("/usuarioFindAll/" + payload).then((res) => res.data);

        let roles = {
          "ROLE_FUNC": ["ROLE_FUNC", "ROLE_EST", "ROLE_PROF"],
          "ROLE_PED": ["ROLE_PED", "ROLE_COOR", "ROLE_FUNC", "ROLE_EST", "ROLE_PROF"],
          "ROLE_DIR": ["ROLE_PED", "ROLE_COOR", "ROLE_FUNC", "ROLE_EST", "ROLE_PROF", "ROLE_PWR"],
          "ROLE_PWR": ["ROLE_PED", "ROLE_COOR", "ROLE_FUNC", "ROLE_EST", "ROLE_PROF", "ROLE_PWR"],
          "ROLE_ADM": ["ROLE_PED", "ROLE_COOR", "ROLE_SEC", "ROLE_FUNC", "ROLE_EST", "ROLE_PROF", "ROLE_PWR", "ROLE_ADM"]
        };

        if (this.role) {
          this.desserts = this.desserts.filter((u) => roles[this.role].includes(u.nome));
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Erro",
          text: "Não foi possível carregar a lista de usuários",
          timer: 3000,
          showConfirmButton: false
        });
      } finally {
        this.isLoading = false;
      }
    },

    getPhoto(item) {
      try {
        return photoUser.getPhotoUser(item.idPessoa);
      } catch (error) {
        Swal.fire("Informação", "Ocorreu um erro ao carregar a foto", "error");
      }
    },

    passwordgenerator() {
      let generator = require("generate-password");
      return generator.generate({ length: 4, numbers: true });
    },

    editItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.editedItem.passwordnew = this.passwordgenerator();
      this.save_status = false;
      this.dialog = true;
      if (item.autorizacoes_nome === "ROLE_EST") this.disabilitaRole = true;
      else this.disabilitaRole = false;
    },

    async close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    async actualizarStatus() {
      let params = { pkUsuario: this.editedItem.pkUsuario };
      Swal.fire({
        title: 'Confirmar ação',
        text: `Deseja realmente ${this.editedItem.activo === 'activa' ? 'inativar' : 'ativar'} este usuário?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim',
        cancelButtonText: 'Cancelar',
        reverseButtons: true
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.isLoading = true;
          try {
            let msg = await axios.post("/mudarStatusByUser", params).then((res) => res.data);
            if (msg && msg.affectedRows) {
              Swal.fire({
                icon: "success",
                title: "Sucesso",
                text: "Status alterado com sucesso",
                timer: 2000,
                showConfirmButton: false
              });
              this.initialize();
            }
          } catch (error) {
            Swal.fire({
              icon: "error",
              title: "Erro",
              text: "Ocorreu um erro ao alterar o status",
              timer: 3000
            });
          } finally {
            this.isLoading = false;
          }
        }
      })
    },

    fecharTelaComponente() {
      this.menuSelected = 0;
      this.initialize();
    },

    showFileChooser(item) {
      this.editedItem = item;
      this.$refs.input.click();
    },

    setImage(e) {
      const file = e.target.files[0];
      if (!file) return;

      if (file.type.indexOf("image/") === -1) {
        Swal.fire({
          icon: "warning",
          title: "Formato inválido",
          text: "Por favor selecione uma imagem (JPG, PNG, etc.)",
          timer: 3000
        });
      } else {
        if (typeof FileReader === "function") {
          this.eventPhoto = e;
          this.menuSelected = 1;
        } else {
          Swal.fire({
            icon: "warning",
            title: "Navegador não suportado",
            text: "Seu navegador não suporta esta funcionalidade",
            timer: 3000
          });
        }
      }
    },

    selecionarMenu(item, opcao) {
      this.editedItem = item;
      if (opcao === 2) this.menuSelected = 2;
      else if (opcao === 3) this.menuSelected = 3;
      else if (opcao === 4) {
        if (this.quantUsuariosActivos >= this.usuarios_permitidos && item.activo !== "activa") {
          Swal.fire({
            icon: "warning",
            title: "Limite atingido",
            text: `Você atingiu o número máximo de usuários ativos permitidos. Contate o suporte para aumentar este limite.`,
            confirmButtonText: 'Entendi'
          });
        } else {
          this.actualizarStatus();
        }
      }
      else if (opcao === 5) this.menuSelected = 5;
    },
  },
};
</script>

<style scoped>
/* Estilos Gerais */
.toolbar-custom {
  border-radius: 8px 8px 0 0;
  padding: 12px 16px;
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e8eb 100%);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
}

.toolbar-content {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 20px;
}

.search-container {
  flex: 1;
  min-width: 250px;
  max-width: 50%;
  display: flex;
  align-items: center;
}

.search-field {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.status-indicators {
  display: flex;
  gap: 8px;
}

/* Efeito Zebra na Tabela */
.user-table>>>tbody tr:nth-of-type(odd) {
  background-color: #f8f9fa;
}

.user-table>>>tbody tr:hover {
  background-color: #e9f5ff !important;
  transform: scale(1);
  transition: all 0.2s ease;
}

.user-table>>>.v-data-table__mobile-table-row {
  background-color: white;
  margin-bottom: 8px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

/* Avatar e Chips */
.user-avatar {
  border: 2px solid #e0e0e0;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.user-avatar:hover {
  transform: scale(1.1);
  border-color: #1976d2;
}

.v-chip {
  font-weight: 500;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

/* Menu de Ações */
.action-menu {
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.action-menu .v-list-item {
  min-height: 40px;
}

.action-menu .v-list-item:hover {
  background-color: #f5f5f5;
}

/* Responsividade - Tablet */
@media (max-width: 960px) {
  .toolbar-content {
    flex-direction: row;
    align-items: center;
  }

  .search-container {
    order: 2;
    width: 100%;
    margin: 8px 0;
  }

  .status-indicators {
    order: 3;
    justify-content: flex-end;
    width: 100%;
  }

  .user-table>>>th {
    font-size: 0.75rem;
  }

  .user-table>>>td {
    font-size: 0.875rem;
    padding: 8px 4px !important;
  }
}

/* Responsividade - Mobile */
@media (max-width: 600px) {
  .toolbar-custom {
    padding: 8px 12px;
    border-radius: 0;
  }

  .toolbar-content {
    flex-direction: column;
    gap: 8px;
    margin-top: 60px;
  }

  .search-container {
    order: 1;
    margin: 4px 0;
  }

  .status-indicators {
    order: 2;
    justify-content: center;
    width: 100%;
  }

  .v-chip {
    font-size: 0.7rem;
    height: 24px;
  }

  .v-avatar {
    width: 20px !important;
    height: 20px !important;
  }

  /* Melhorias na tabela mobile */
  .user-table>>>.v-data-table__mobile-row {
    padding: 16px 12px;
    margin-bottom: 12px;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    position: relative;
    overflow: hidden;
  }

  .user-table>>>.v-data-table__mobile-row::before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 4px;
  }

  .user-table>>>.v-data-table__mobile-row__cell {
    padding: 6px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .user-table>>>.v-data-table__mobile-row__cell:before {
    content: attr(data-label);
    font-weight: 600;
    color: #555;
    margin-right: 16px;
    width: 100px;
    font-size: 0.8rem;
    flex-shrink: 0;
  }

  .user-table>>>.v-data-table__mobile-row__cell .v-chip {
    margin-left: auto;
  }

  /* Avatar mobile */
  .user-table>>>.v-data-table__mobile-row .user-avatar {
    width: 40px;
    height: 40px;
  }

  /* Menu de ações mobile */
  .action-menu {
    min-width: 180px;
  }

  .action-menu .v-list-item__title {
    font-size: 0.85rem;
  }
}

/* Ajustes para telas muito pequenas */
@media (max-width: 600px) {
  .search-field {
    font-size: 0.8rem;
  }

  .user-table>>>.v-data-table__mobile-row__cell:before {
    width: 80px;
    font-size: 0.75rem;
  }

  .user-table>>>.v-data-table__mobile-row__cell {
    font-size: 0.8rem;
  }

  .v-chip--outlined {
    padding: 0 6px;
  }

  .user-table>>>tbody tr:nth-of-type(odd) {
    background-color: #ececec;
  }
}

/* Animação suave para carregamento */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.user-table>>>tbody tr {
  animation: fadeIn 0.3s ease forwards;
}

.user-table>>>tbody tr:nth-child(1) {
  animation-delay: 0.1s;
}

.user-table>>>tbody tr:nth-child(2) {
  animation-delay: 0.2s;
}

.user-table>>>tbody tr:nth-child(3) {
  animation-delay: 0.3s;
}

/* ... e assim por diante para mais linhas se necessário */
</style>
